export default __webpack_public_path__ + "static/media/pic11.4c74d059.jpg";